import { TextInput } from '@core/components/Inputs';
import { mensagemCampoObrigatorio } from '@core/util/mensagemUtil';
import { FormControl, Grid, IconButton, makeStyles } from '@material-ui/core';
import empresaOnboardingApi from 'app/services/api/empresaOnboardngApi';
import { parametrosNotaFiscalApi } from 'app/services/api/parametrosNotaFiscalApi';
import * as MessageActions from 'app/store/actions/fuse/message.actions';
import { GlobalContext } from 'app/store/globalcontext';
import { FormikProvider, useFormik } from 'formik';
import moment from 'moment';
import React, { useContext, useEffect } from 'react';
import { FaEye, FaEyeSlash, FaInfoCircle } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import * as yup from 'yup';
import { OnboardingContext } from '../OnboardingContext';
import OnboardingLayout from '../OnboardingLayout';
import InformativoLateral from './InformativoLateral';
import UploadCertificado from './upload-certificado/UploadCertificado';

const schema = yup.object().shape({
  certificado: yup
    .object()
    .nullable()
    .required(mensagemCampoObrigatorio('o certificado')),
  senha: yup
    .string()
    .nullable()
    .required(mensagemCampoObrigatorio('a senha')),
});

const useStyles = makeStyles(() => ({
  icon: {
    marginTop: '5px',
    color: '#2e62b8',
  },
  icon2: {
    padding: 2,
    color: '#707070',
  },
}));

const CertificadoDigitalOnboarding = () => {
  useEffect(() => {
    carregadadosParametros();
    // Efeito de montagem: roda uma única vez. Incluir as dependências reexecutaria a carga
    // inicial a cada render (loop de chamadas à API).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const carregadadosParametros = async () => {
    let certificado = parametrosNotaFiscal.certificado;

    let resp = await parametrosNotaFiscalApi().getParametrosNotaFiscalEmpresa();

    let parametros = {
      id: resp.data?.id,
      certificado: resp.data?.certificado || certificado,
      senha: resp.data?.certificado?.senha || certificado?.senha,
      certificadoSelecionado: resp.data?.certificado || certificado,
    };
    formik.setValues(parametros);
    setParametrosNotaFiscal(parametros);
    setLoading(false);
  };

  const [, setLoading] = useContext(OnboardingContext).loading;
  const [empresa] = useContext(GlobalContext).empresa;
  const [, setAtualizarEtapa] = useContext(OnboardingContext).atualizarEtapa;
  const [parametrosNotaFiscal, setParametrosNotaFiscal] = useContext(OnboardingContext).parametrosNotaFiscal;

  const dispatch = useDispatch();

  const submit = async () => {
    formik.setSubmitting(true);
    formik.submitForm();

    let isValid = formik.isValid;

    if (!isValid) {
      formik.setSubmitting(false);
      return;
    }

    try {
      const _parametrosNotaFiscal = JSON.parse(JSON.stringify(formik.values));

      if (_parametrosNotaFiscal.senha) {
        _parametrosNotaFiscal.certificado.senha = _parametrosNotaFiscal.senha;
      }

      let response;
      if (_parametrosNotaFiscal.certificadoSelecionado) {
        _parametrosNotaFiscal.certificado = {
          ..._parametrosNotaFiscal.certificadoSelecionado,
          senha: _parametrosNotaFiscal.certificado.senha,
        };
        _parametrosNotaFiscal.certificadoSelecionado = undefined;
      }
      if (_parametrosNotaFiscal.id) {
        response = await parametrosNotaFiscalApi().atualizar(_parametrosNotaFiscal.id, _parametrosNotaFiscal);
      } else {
        response = await parametrosNotaFiscalApi().cadastrar(_parametrosNotaFiscal);
      }

      if (response.data) {
        setParametrosNotaFiscal(response.data);
        saveOboarding();
      }
    } catch (error) {
      if (error?.response?.data?.fieldErrors?.length) {
        const err = error.response.data.fieldErrors[0];
        dispatch(MessageActions.showMessage({ err, variant: 'error' }));
      } else {
        const message = error?.response?.data?.message;
        dispatch(MessageActions.showMessage({ message, variant: 'error' }));
      }
    }
    formik.setSubmitting(false);
  };

  const saveOboarding = async () => {
    try {
      setLoading(true);

      const empresaRequest = empresa;
      const requestObject = { empresaRequest };

      let resp = await empresaOnboardingApi.atualizar(empresa.id, 'CERTIFICADO_DIGITAL', requestObject);
      if (resp) {
        setAtualizarEtapa(true);
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const formik = useFormik({
    validationSchema: schema,
    initialValues: {
      id: parametrosNotaFiscal?.id,
      certificado: parametrosNotaFiscal?.certificado,
      senha: parametrosNotaFiscal?.certificado?.senha,
      certificadoSelecionado: parametrosNotaFiscal?.certificado,
    },
    onSubmit: () => null,
    validateOnChange: true,
    validateOnMount: true,
    enableReinitialize: true,
  });
  const isCertificadoVencido = (dataValidade) => {
    const dataAtual = new Date();
    const dataValidadeCertificado = moment(dataValidade);
    return dataValidadeCertificado.isBefore(dataAtual);
  };

  const _errors = {
    certificado: (formik.submitCount > 0 || formik.touched?.certificado) && formik.errors?.certificado,
    certificadoSelecionado:
      (formik.submitCount > 0 || formik.touched?.certificadoSelecionado) && formik.errors?.certificadoSelecionado,
    senha: (formik.submitCount > 0 || formik.touched?.senha) && formik.errors?.senha,
  };
  const style = useStyles();

  return (
    <OnboardingLayout
      wizardStep={4}
      onSubmit={submit}
      leftSidebarContent={
        <InformativoLateral
          titulo="Nota fiscal"
          subTitulo="Certificado digital"
          imagem="assets/images/onboarding/5.svg"
        >
          Com o Certificado Digital A1 você poderá realizar emissão de suas notas fiscais em poucos minutos.
        </InformativoLateral>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Grid container style={{ marginBottom: '3%' }}>
              <Grid item lg={2} md={2} sm={2} xs={2} />
              <Grid item lg={8} md={8} sm={8} xs={8}>
                <UploadCertificado />
              </Grid>
              <Grid item lg={2} md={2} sm={2} xs={2} />
              <Grid item lg={2} md={2} sm={2} xs={2} />
              <Grid item lg={8} md={8} sm={8} xs={8} style={{ marginTop: '3%' }}>
                <Grid container spacing={3}>
                  <Grid item lg={6} md={6} sm={6} xs={6}>
                    <FormControl variant="outlined" style={{ width: '100%' }}>
                      <TextInput
                        autoFocus
                        id="senha"
                        name="senha"
                        required
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        type="password"
                        value={formik.values?.senha}
                        maxLength={500}
                        fullWidth
                        variant="outlined"
                        label="Senha do certificado digital"
                        error={_errors.senha}
                        helperText={_errors.senha}
                        touched={!!_errors.senha}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item lg={2} md={2} sm={2} xs={2}>
                    <IconButton
                      id="iconeSenha"
                      onClick={() => {
                        formik.handleChange({ target: { id: 'mostrarSenha', value: !formik.values?.mostrarSenha } });
                        const senha = document.getElementById('senha');
                        senha.type = formik.values?.mostrarSenha ? 'password' : 'text';
                      }}
                    >
                      {formik.values?.mostrarSenha ? (
                        <FaEyeSlash size={20} className={style.icon} />
                      ) : (
                        <FaEye size={20} className={style.icon} />
                      )}
                    </IconButton>
                  </Grid>
                  {formik.values?.certificado?.dataValidade ? (
                    <Grid item lg={4} md={4} sm={4} xs={4}>
                      <div
                        style={{
                          background: isCertificadoVencido(formik.values.certificado.dataValidade)
                            ? '#B53838'
                            : '#3286A8',
                          padding: '7px',
                          textAlign: 'center',
                          marginTop: '10px',
                        }}
                      >
                        <span style={{ fontFamily: 'Muli', fontSize: 15, fontWeight: 600, color: '#fff' }}>
                          Vencimento em{' '}
                          {formik.values?.certificado?.dataValidade
                            ? moment(formik.values.certificado.dataValidade).format('DD/MM/YYYY')
                            : ''}
                        </span>
                      </div>
                    </Grid>
                  ) : (
                    <></>
                  )}

                  <Grid container item xs={12}>
                    <FaInfoCircle size={20} className={style.icon2} />
                    <span style={{ fontSize: '12px', color: '#707070', marginLeft: '9px' }}>
                      A senha e validade do certificado são informados no momento da sua compra.
                    </span>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={2} md={2} sm={2} xs={2} />
            </Grid>
          </FormikProvider>
        </>
      }
    />
  );
};

export default CertificadoDigitalOnboarding;
